export interface Banner {
    text: string;
    enabled: boolean;
    color: string;
    url: string;
}

export const defaultBanner = (): Banner => ({
    text: '',
    enabled: false,
    color: '#4B9EFE',
    url: ''
});
